import React from 'react';
import { css } from 'twin.macro';
import ColorDropDown from './ColorDropDown';
import { FaTrash } from 'react-icons/fa';
import { fetchWrapper } from '../../../../../_helpers';
import { useDispatch } from 'react-redux';
import { getUserData } from '../../../../../_redux';
import { toast } from 'react-toastify';

function LabelItem({ title, color = 'red' }) {
	const dispatch = useDispatch();
	const handleDelete = async () => {
		try {
			const confirm = window.confirm('Are you sure');
			if (confirm) {
				const response = await fetchWrapper.patch('label', {
					key: title,
					category: 'visits',
				});
				console.log(response, 'response');
				dispatch(getUserData());
				toast.success('Label deleted successfully');
			}
		} catch (err) {
			console.log(err);
		}
	};
	const handleColorChange = async (color) => {
		try {
			const response = await fetchWrapper.post('label', {
				key: title,
				category: 'visits',
				color: color,
			});
			console.log(response, 'response');
			dispatch(getUserData());
			toast.success('Label color changed successfully');
		} catch (err) {
			console.log(err);
		}
	};
	return (
		<div className="d-flex align-items-center w-10">
			<ColorDropDown color={color} setColor={handleColorChange} />
			<h5
				className="ml-3 d-flex align-items-center"
				css={css`
					width: 200px;
				`}
			>
				{title}
			</h5>
			<div className="ml-4 cursor-pointer" onClick={handleDelete}>
				<FaTrash size={20} className="text-danger" />
			</div>
		</div>
	);
}

export default LabelItem;
